import React, { useEffect } from 'react';
import PropTypes from "prop-types";
import MethodTitle from "../../misc/Method-title/MethodTitle";
import {getI18nTextWithContext} from "wipi-common/src/lib/i18n";
import {useI18nContext} from "../../i18n/I18nContext";
import verifiedIcon from '../../../assets/icons/verified.svg'
import verifiedIconDark from '../../../assets/icons/verified-dark.svg'
import LOG from "wipi-common/src/lib/logging/logger";
import {LOG_EVENTS} from "wipi-common/src/lib/logging/events";

export default function EudiwIdSuccess({caseInfo}) {
    const context = useI18nContext();

    useEffect(() => {
        LOG.logInfo(LOG_EVENTS.EW_SUCCESS)
    }, []);

    return (
        <>
            <div className="headless">
                <div className="col-xl-6 col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-12 col-12">
                    <div className="row max-w-75 mx-auto">
                        <MethodTitle
                            heading={getI18nTextWithContext(context, 'startEudiwId.heading')}
                            subHeading={null}
                            info={null}
                            testId="hfmvwi41a4p9"/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex flex-column align-items-center justify-content-center">
                            <img src={verifiedIcon} alt="verified" className="dark-img m-4 mw-100"
                                 style={{width: '80px'}} data-test-id="34anlfjqvsc4"/>
                            <img src={verifiedIconDark} alt="verified" className="light-img m-4 mw-100"
                                 style={{width: '80px'}} data-test-id="34anlfjqvsc4"/>
                        {getI18nTextWithContext(context, 'eudiwIdSuccess.description')}
                    </div>
                </div>
            </div>
        </>
    );
}

EudiwIdSuccess.propTypes = {
    caseInfo: PropTypes.object.isRequired
};
